import {
  REGISTRATION_SUPPORT_EMAIL,
  REGISTRATION_SUPPORT_PHONE,
  quickCodeLookupFailureParagraphs,
} from '@buxus/shared'

const SUPPORT_EMAIL_DISPLAY = 'Help@Buxus.io'

/** Rich Quick Code lookup failure body (mobile `QuickCodeForm` modal parity). */
export function QuickCodeLookupErrorBody() {
  const line1 = quickCodeLookupFailureParagraphs()[0]
  const phoneHref = `tel:${REGISTRATION_SUPPORT_PHONE.replace(/\D/g, '')}`
  const mailHref = `mailto:${REGISTRATION_SUPPORT_EMAIL}`

  return (
    <div className="reg-quick-code-error-body">
      <p>{line1}</p>
      <p>
        Make sure you haven&apos;t typed &quot;
        <span className="reg-quick-code-error-char">O</span>&quot; for &quot;
        <span className="reg-quick-code-error-char">0</span>&quot; or vice-versa.
      </p>
      <p>
        If you have any issues, big or small, please contact us for help at{' '}
        <a href={phoneHref}>{REGISTRATION_SUPPORT_PHONE}</a> or{' '}
        <a href={mailHref}>{SUPPORT_EMAIL_DISPLAY}</a>.
      </p>
    </div>
  )
}
